import { useEffect, useState } from 'react';
import { imageToBlob } from 'utils/ImageToBlob';

export function useBlobImage(photoUrl) {
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    let objectUrl;

    async function convertPhoto() {
      if (photoUrl) {
        const localURL = await imageToBlob(photoUrl);
        if (localURL) {
          setPhoto(localURL);
          objectUrl = localURL;
        }
      }
    }

    convertPhoto();

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [photoUrl]);

  return photo;
}
